import { flatMap, uniqBy } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { maxTicketsThresholdReached, resetmaxTicketsThreshold } from '../../../cart/actions/cart-actions';
import { PriceType } from '../../../classes/price-type';
import { CartSeat, Seat, SeatPriceQuantity, SeatZone } from '../../../classes/seat';
import { CartHelpers } from '../../../helpers/cart-helpers';
import { getCurrencyFormat } from '../../../helpers/currency-format';
import { IAppState } from '../../../reducers';
import { IAppSettingsModel } from '../../../reducers/fetch-settings-reducer';
import PriceTypeQuantities from '../price-type-quantities';
import RadioGroup from '../../../common/radio/radio-group';
import { IOptionGroup, IOption } from '../../../classes/seating-option';

import * as isEqual from 'react-fast-compare';

class PriceTypeOption implements IOption {
    public id: string;
    public name: string;
    public selected: boolean = false;
    public price: SeatPriceQuantity;
}

class PriceTypeOptionGroup implements IOptionGroup {
    public id: string;
    public name: string;
    public isCheckbox: boolean;
    public seatLimit: number;
    public seatLimitText: string;
    public groupSeatSelectedQuantity: number;
    public groupSelected: boolean;
    public options: Array<PriceTypeOption>;
    public selectedOptionId: string;
}

export interface StateToProps {
    seats: Array<Seat>;
    cartSeats: Array<CartSeat>;
    levelPricing: Array<SeatZone>;
    appSettingsModel: IAppSettingsModel;
    defaultPTQuantities: Array<SeatPriceQuantity>;
    //onSelectPricing: (priceQuantities: SeatPriceQuantity[]) => any;
    isGAZone?: boolean;
};

export interface OwnProps {
    selectedPriceQuantities: Array<SeatPriceQuantity>;
    selectedPriceTypes: Array<PriceType>;
    onSelectPricing: (priceQuantities: SeatPriceQuantity[]) => any;
    store?: any;
}

interface DispatchToProps {
    resetMaxTicketsThreshold: () => any;
    maxTicketsThresholdReached: (errorPricesText: string) => any;
}

export type ISeatInfoPricesProps = StateToProps & DispatchToProps & OwnProps;

class SeatInfoPrices extends React.Component<ISeatInfoPricesProps, null>{
    static defaultProps = {
        isGAZone: false
    }

    componentWillMount() {
        this.props.resetMaxTicketsThreshold();
    }

    shouldComponentUpdate(nextProps: ISeatInfoPricesProps, nextState) {
        return this.props.cartSeats.length != nextProps.cartSeats.length
            || this.props.seats.length != nextProps.seats.length
            || !isEqual(this.props, nextProps);
    }

    componentWillReceiveProps(nextProps: ISeatInfoPricesProps) {
        if (this.props.cartSeats.length != nextProps.cartSeats.length) {
            this.updateMaxTicketErrorMessaging(nextProps);
        }
    }

    updateMaxTicketErrorMessaging(props: ISeatInfoPricesProps) {
        const maxedOutPrices = props.defaultPTQuantities.filter(pt => CartHelpers.maxSeatsInCart(pt.seatPricing.priceTypeId, props.cartSeats, props.appSettingsModel.priceTypeSettings));
        if (maxedOutPrices.length == 0) {
            props.resetMaxTicketsThreshold();
        } else {
            const errorPricesText = this.getErrorPricesText(maxedOutPrices);
            props.maxTicketsThresholdReached(errorPricesText);
        }
    }

    getErrorPricesText(prices: SeatPriceQuantity[]) {
        if (prices.length == 1) {
            return prices[0].seatPricing.priceTypeDescription;
        } else {
            return "several price types";
        }
    }

    getSelectedPriceTypeId(): number {
        if (this.props.selectedPriceQuantities != null && this.props.selectedPriceQuantities.length > 0
            && this.props.selectedPriceQuantities[0].seatPricing !== undefined) {
            return this.props.selectedPriceQuantities[0].seatPricing.priceTypeId;
        }
        return 0;
    }

    getPriceTypeOptions() {
        let priceTypes = this.props.defaultPTQuantities;
        var activeSeatInCart = this.props.cartSeats.filter(cartSeat => this.props.seats.some(seat => seat.seatId === cartSeat.seatId));

        var priceTypeCarted = null;

        if (activeSeatInCart.length > 0) {
            priceTypeCarted = activeSeatInCart[0].selectedPricing.priceTypeId;
        }

        let priceTypeOptionArray: Array<PriceTypeOption> = priceTypes.map(price => {
            var option = {
                id: price.seatPricing.priceTypeId.toString(),
                price: price,
                name: `${getCurrencyFormat(this.props.appSettingsModel.currencyFormat, price.seatPricing.price)} - ${price.seatPricing.priceTypeDescription}`,
                selected: price.quantity > 0
            } as PriceTypeOption;

            if (priceTypeCarted !== null && price.seatPricing.priceTypeId === priceTypeCarted && priceTypes.filter(pt => pt.quantity > 0).length === 0) {
                option.selected = true;
            }
            return option;
        });

        return priceTypeOptionArray;
    }

    render() {
        let body: JSX.Element;

        const priceTypeOptionGroup: PriceTypeOptionGroup = {
            id: "priceTypesForSeat",
            name: "priceTypesForSeat",
            isCheckbox: false,
            options: this.getPriceTypeOptions(),
            selectedOptionId: this.getSelectedPriceTypeId().toString()
        } as PriceTypeOptionGroup;

        if (this.props.isGAZone) {
            //need to take into account global max for ga zones  this.props.appSettingsModel.maxTicketQuantity
            return <PriceTypeQuantities {...this.props} />

        } else if (this.props.defaultPTQuantities.length === 1) {
            let priceDisplay = "";

            if (this.props.defaultPTQuantities[0].seatPricing.price === 0 && this.props.appSettingsModel.exchangeFreeLabel.length > 0) {
                priceDisplay = this.props.appSettingsModel.exchangeFreeLabel;
            } else {
                priceDisplay = getCurrencyFormat(this.props.appSettingsModel.currencyFormat, this.props.defaultPTQuantities[0].seatPricing.price);
            }

            body = <span className="seat-info-prices-list-text">{priceDisplay} - {this.props.defaultPTQuantities[0].seatPricing.priceTypeDescription}</span>

        } else {
            body = (
                <div>
                    <RadioGroup disabled={false} group={priceTypeOptionGroup} stateChangeFunction={this._onPriceButtonClick} />
                </div>
            );
        }

        return (
            <div className="seat-info-prices">
                <div className="seat-info-prices-list">
                    {body}
                </div>
            </div>
        );
    }

    _onPriceButtonClick = (selectedRadio) => {
        this.props.onSelectPricing([{ ...selectedRadio[0].price, quantity: 1 }]);
    };
}

function getSelectedPrices(state: IAppState, levelPricing, priceTypeSettings: Array<PriceType>, seats: Array<Seat>, selectedPriceQuantities, selectedPriceTypes, isGAZone: boolean): Array<SeatPriceQuantity> {
    const zonePrices = levelPricing.filter(pricing =>
        seats.map(seat => seat.tessituraSeat.zoneId)
            .some(zoneId => zoneId === pricing.zoneId.toString()));

    let selectedPrices = uniqBy(flatMap(zonePrices, zone => zone.prices.map(price => {
        price.zoneId = zone.zoneId;
        return price;
    })), 'priceTypeId');

    if (!isGAZone) {
        const selectedPriceTypeIds = selectedPriceTypes.map(pt => {
            return pt.priceTypeId;
        });

        selectedPrices = selectedPrices.filter(price => {
            return selectedPriceTypeIds.indexOf(+price.priceTypeId) >= 0;
        });
    } else {
    }

    //let filteredPrices = selectedPrices.filter(price =>
    //   props.appSettingsModel.priceTypeSettings.filter(ptSetting => ptSetting.priceTypeId === +price.priceTypeId)[0].maxQuantity <= 0);

    return selectedPrices.filter(price => priceTypeSettings.filter(ptSetting => ptSetting.priceTypeId === +price.priceTypeId).length > 0)
        .map(price => {
            let priceTypeSettingMax = priceTypeSettings.filter(ptSetting => ptSetting.priceTypeId === +price.priceTypeId)[0];
            let selectedPriceQuantity = selectedPriceQuantities.filter(selectedPQ => selectedPQ.seatPricing !== undefined && selectedPQ.seatPricing.priceTypeId === price.priceTypeId)[0];

            return {
                seatPricing: price,
                maxQuantity: Math.min((priceTypeSettingMax.clientMaxQuantity > 0 ? priceTypeSettingMax.clientMaxQuantity : 100), seats.filter(seat => +seat.tessituraSeat.zoneId === price.zoneId).length, price.maxSeats),
                quantity: selectedPriceQuantity === undefined ? 0 : selectedPriceQuantity.quantity
            }
        })
}

function mapStateToProps(state: IAppState, ownProps: OwnProps): StateToProps {
    var selectedSeats = state.seatMapModel.selectedSeats;
    var isGaZone = state.seatMapModel.selectedSeats.length > 1;
    return {
        defaultPTQuantities: getSelectedPrices(state,
            state.seatMapModel.allSeatPricing,
            state.appSettingsModel.priceTypeSettings,
            selectedSeats,
            ownProps.selectedPriceQuantities,
            ownProps.selectedPriceTypes,
            isGaZone
        ),
        appSettingsModel: state.appSettingsModel,
        cartSeats: state.cartModel.seats,
        isGAZone: isGaZone,
        levelPricing: state.seatMapModel.allSeatPricing,
        seats: selectedSeats
    }
}

function mapDispatchToProps(dispatch: any): DispatchToProps {
    return {
        resetMaxTicketsThreshold: () => dispatch(resetmaxTicketsThreshold()),
        maxTicketsThresholdReached: (errorPricesText) => dispatch(maxTicketsThresholdReached(true, errorPricesText))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SeatInfoPrices);

